<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Enviar Arquivos</h2>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm5>
                <v-select
                  :items="setor"
                  filled
                  v-model="item.fk_setor"
                  item-text="descricao"
                  item-value="id"
                  label="Setor"
                  @input="onSetorSelect()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm5>
                <v-select
                  :items="tipo_documento"
                  filled
                  v-model="item.fk_tipo_documento"
                  item-text="descricao"
                  item-value="id"
                  label="Tipo Documento"
                  @input="onDocumentoSelect()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm2>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menuData"
                  :nudge-left="80"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field slot="activator" v-model="item.data_documento" label="Data" readonly></v-text-field>
                  <v-date-picker
                    v-model="dataPicker"
                    no-title
                    locale="pt-br"
                    @input="onInputData()"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Selecionar Arquivo"
                  @click="pickFile"
                  v-model="item.fileName"
                  prepend-icon="attach_file"
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="file"
                  accept=".pdf"
                  @change="onFilePicked"
                >
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="item.descricao"
                  label="Descrição"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12>
                <v-textarea
                v-model="item.resumo"
                label="Resumo"
                no-resize
                rows="5"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/ged')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="onSendFileClick" :disabled="!valid" :loading="loading">Enviar</v-btn>
      </v-card-actions>
    </v-card>
    <!-- <debug v-model="$data.item"/> -->
  </span>
</template>
<script>
// accept=".pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
import { showError, formatDateToBr } from '@/utils'
import atualizacaoService from '@/services/atualizacao'
import Swal from 'sweetalert2'

export default {
  name: 'atualizacao',
  data () {
    return {
      menuData: false,
      dataPicker: '',
      setor: [],
      tipo_documento: [],
      fotopessoa: '',
      item: {
      // tipo: '',
        fileName: '',
        file: '',
        descricao: '',
        data_documento: '',
        resumo: '',
        fk_tipo_documento: '',
        fk_setor: ''
      },
      // tipos: ATUALIZACAO_ENUM.values,
      atividadesItens: [],
      valid: false,
      loading: false,
      isButtonSaveLoading: false,
      rules: {
        file: [v => !!v || 'Campo Requerido']
      }
    }
  },
  watch: {
    dataPicker () {
      this.item.data_documento = formatDateToBr(this.dataPicker)
    }
  },
  async mounted () {
    try {
      let id = this.$route.params.id
      this.loading = true
      this.setor = []
      this.tipo_documento = []
      const s = await atualizacaoService.getSetor()
      if (s.data !== undefined) {
        this.setor = s.data
      }
      const d = await atualizacaoService.getDocumento()
      if (d.data !== undefined) {
        this.tipo_documento = d.data
      }
      if (id === undefined) {
        this.modo = 'I'
        return
      }
      this.modo = 'A'
      var r = await atualizacaoService.getId(id)
      this.item = r
      this.dataPicker = r.data_documento
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    onInputData () {
      this.menuData = false
    },
    async onSetorSelect () {
    // console.log(this.atendimento)
    // this.idprofissional = this.atendimento.fk_servico
    },
    async onDocumentoSelect () {
    // this.idprofissional = this.atendimento.fk_servico
    },
    pickFile () {
      this.$refs.file.click()
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] === undefined) return
      this.item.fileName = files[0].name
      const fr = new FileReader()
      fr.readAsDataURL(files[0])
      fr.addEventListener('load', () => {
        this.item.file = files[0]
      })
    },
    async onSendFileClick () {
      try {
        this.loading = true
        var formData = new FormData()
        // formData.append('file', this.item.file, this.item.fileName)
        // formData.append('file', this.item.file)
        // formData.append('resumo', this.item.resumo)
        // console.log(formData)
        // formData.append('file', this.item.file)
        // formData.append('descricao', this.item.descricao)
        // console.log(formData)
        // formData.set('file', this.item.file)
        var tudo = this.item.fileName + '@' + this.item.fk_setor + '@' + this.item.fk_tipo_documento + '@' + this.item.data_documento + '@' + this.item.descricao + '@' + this.item.resumo
        // formData.set('file', this.item.file, this.item.descricao + '.pdf')
        // formData.set('file', this.item.file, tudo + '.pdf')
        formData.set('file', this.item.file, tudo)
        let result = await atualizacaoService.sendFile(formData)
        if (result !== undefined) {
          this.item.filename = '.'
          this.item.file = '.'
          this.item.descricao = ''
          this.item.resumo = ''
          Swal.fire({
            title: 'Arquivo enviado com sucesso',
            confirmButtonText: 'OK',
            confirmButtonColor: '#3085d6'
          }).then((result) => {})
          return
        }
      } catch (error) {
        showError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
